export const IconLogout = ({ className }: { className?: string }) => (
  <svg className={`fill-current ${className}`} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 5C8 5.55229 7.55228 6 7 6L6 6V18H7C7.55228 18 8 18.4477 8 19C8 19.5523 7.55228 20 7 20H5C4.44771 20 4 19.5523 4 19V5C4 4.44771 4.44771 4 5 4H7C7.55228 4 8 4.44771 8 5ZM18 7.42L20.82 11.42C21.0709 11.7758 21.0628 12.253 20.8 12.6L17.8 16.6C17.6111 16.8518 17.3148 17 17 17C16.7836 17 16.5731 16.9298 16.4 16.8C15.9582 16.4686 15.8686 15.8418 16.2 15.4L18 13H10C9.44771 13 9 12.5523 9 12C9 11.4477 9.44771 11 10 11H18.09L16.37 8.58L16.3649 8.57282C16.048 8.12052 16.1577 7.49694 16.61 7.18C17.0604 6.86393 17.6816 6.97119 18 7.42Z"
    />
  </svg>
)
